"use client";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { useBranch } from "@/store/branch";
import { identify, setTenantGroup, trackPageView } from "@/lib/analytics";

/**
 * Mounted once near the top of the tree. No DOM. Three jobs:
 *   1. Fire `$pageview` on every route change.
 *   2. `identify()` once we know who the user is (and reset isn't yet wired).
 *   3. `group("company", tenantId)` once the branch config resolves.
 *
 * No-op when PostHog isn't initialised (key not set in env).
 */
export function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  const { user } = useAuth();
  const { branchConfig } = useBranch();

  // Page views
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  // Identify
  useEffect(() => {
    if (!user) return;
    const u = user as { id?: string; phone?: string; name?: string; email?: string };
    if (!u.id) return;
    identify(u.id, {
      phone: u.phone,
      name: u.name,
      email: u.email,
    });
  }, [user]);

  // Tenant group
  useEffect(() => {
    const tenantId = (branchConfig as { tenantId?: string } | null)?.tenantId;
    if (tenantId) setTenantGroup(tenantId);
  }, [branchConfig]);

  return null;
}
